module.exports = __webpack_public_path__ + "static/media/contact04.bd4bab3d.png";